export const PAYMENTS = '/payments'
export const STUDENT_PAYMENTS = '/student-payments'
